var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPart2GuidesIcon = function SvgPart2GuidesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M8.158 3.902a.2.2 0 0 0 .129.054h3.573a.198.198 0 0 0 .137-.327L9.887 1.52a.8.8 0 0 0-.538-.22H7.384a.759.759 0 0 0-.531 1.297z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M13.537 8.484h3.558a1.882 1.882 0 0 0 1.867-2.216 1.96 1.96 0 0 0-1.95-1.578H5.108l-1.29-1.297a.8.8 0 0 0-.539-.22H1.762a.76.76 0 0 0-.645.356.76.76 0 0 0 0 .759l1.896 3.794a.76.76 0 0 0 .676.417h4.446a.19.19 0 0 1 .129.326L5.335 11.74a.759.759 0 0 0 .531 1.297H8.59a.8.8 0 0 0 .539-.22l4.271-4.28a.22.22 0 0 1 .137-.052zM17.095 15.312a2 2 0 0 0-.758.167c-.091.046-.167 0-.22-.144a2.656 2.656 0 1 0-2.413 3.794h3.414a1.897 1.897 0 0 0 0-3.794z"
  })));
};
export { SvgPart2GuidesIcon as ReactComponent };